import React, { useState, useEffect } from 'react';
import Loginheader from '../Loginheader';
import Menu from '../Menu';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import { Container, Row, Col, Form, Table, Button } from 'react-bootstrap';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-datepicker';

const Bank_Charges_List = (props) => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem("sessionId");

    const [onceRun, setOnceRun] = useState(false);
    const [mbcRight, setMbcRight] = useState([]);
    const [mbcData, setMbcData] = useState([]);

    // Dialog states
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    // UI state — same pattern as original
    const [showAddNewBtn, setShowAddNewBtn] = useState(true);
    const [formMode, setFormMode] = useState('Q'); // Q = View, A = Add, E = Edit

    // Filter states
    const [filterLimit, setFilterLimit] = useState("All");
    const [filterStatus, setFilterStatus] = useState("All");

    // Form field states — new mbc_ fields
    const [mbcSrno, setMbcSrno] = useState(0);
    const [mbcFromDate, setMbcFromDate] = useState(new Date());
    const [mbcToDate, setMbcToDate] = useState(new Date());
    const [mbcIsd, setMbcIsd] = useState("");
    const [mbcValueFrom, setMbcValueFrom] = useState(0);
    const [mbcValueTo, setMbcValueTo] = useState(0);
    const [mbcStatus, setMbcStatus] = useState(1); // 1 = Active, 0 = Inactive
    const [currency, setCurrency] = useState([]);
    const [reqIsd, setReqIsd] = useState("0");
    const [mbcCharges, setMbcCharges] = useState();
    const [ddSrchIssuer, setDdSrchIssuer] = useState([]);
    const [mbcIssuer, setMbcIssuer] = useState("0");

    // Guards against duplicate save / unnecessary update calls
    const [isSaving, setIsSaving] = useState(false);
    const [originalFormData, setOriginalFormData] = useState(null);
    const [lastSavedFormData, setLastSavedFormData] = useState(null);
    const [mbcNostroType, setMbcNostroType] = useState("0");


    useEffect(() => {
        if (onceRun) return;

        Common.callApi(Common.apiRight, [sid, 'all', 'BANK_CHARGES'], function (result) {
            let resp = JSON.parse(result);
            console.log("right", resp);
            if (resp.query === "1") {
                setMbcRight(resp);
            } else {
                navigate('/');
                return;
            }
        });
        Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
            const issuerlist = JSON.parse(result);
            setDdSrchIssuer(issuerlist);
        });

        Common.callApi(Common.apiIsd, [sid, 'ddlistjsonselect'], function (result) {
            const list = JSON.parse(result);
            setCurrency(list);
        });

        setOnceRun(true);
    }, [onceRun, sid, navigate]);

    const showList = () => {
        // $(".loader").show();
        if (filterLimit === "") {
            setMsgText("Set Limit to Get Data");
            setMsgBox(true);
            return;
        }

        const obj = {
            limit: filterLimit,
            status: filterStatus,
            issuer: mbcIssuer,
            currency: mbcIsd,
        };

        Common.callApi(Common.apiBankCharges, [sid, 'getBankChargesList', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setMbcData(resp);
            setFilterLimit("All");
            $(".loader").hide();
        });
    }

    const refreshList = () => {
        const obj = {
            limit: "All",
            status: "All",
            issuer: "0",
            currency: "",
        };
        Common.callApi(Common.apiBankCharges, [sid, 'getBankChargesList', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setMbcData(resp);
            setFilterLimit("All");
            setFilterStatus("All");
            setMbcIssuer("0");
            setMbcIsd("");
        });
    }

    const addNew = () => {
        setShowAddNewBtn(false);
        setFormMode('A');
        setMbcSrno(0);
        setMbcIssuer("");
        setMbcFromDate(new Date());
        setMbcToDate(new Date());
        setMbcIsd("");
        setMbcCharges(0);
        setMbcValueFrom(0);
        setMbcValueTo(0);
        setMbcStatus(1);
        setOriginalFormData(null);
        setLastSavedFormData(null);
        setMbcNostroType("0");
    }

    const fillEditForm = (srno) => {
        const parseDate = (d) => { const [y, m, day] = d.split('-'); return new Date(y, m - 1, day); };
        $(".loader").show();
        setShowAddNewBtn(false);
        setFormMode('Q');
        Common.callApi(Common.apiBankCharges, [sid, 'viewBankCharges', srno], (result) => {
            let resp = JSON.parse(result);
            resp = resp[0];
            setMbcSrno(resp.mbc_srno);
            setMbcIssuer(String(resp.mbc_issuer));
            setMbcFromDate(parseDate(resp.mbc_from_date));
            setMbcToDate(parseDate(resp.mbc_to_date));
            setMbcIsd(resp.mbc_isd);
            setMbcValueFrom(resp.mbc_value_from);
            setMbcValueTo(resp.mbc_value_to);
            setMbcStatus(resp.mbc_active);
            setMbcCharges(resp.mbc_charges);
            setMbcNostroType(resp.mbc_nostro_type);

            // snapshot of original values, used later to detect "no changes"
            setOriginalFormData({
                mbcIssuer: String(resp.mbc_issuer),
                mbcFromDate: parseDate(resp.mbc_from_date).getTime(),
                mbcToDate: parseDate(resp.mbc_to_date).getTime(),
                mbcIsd: String(resp.mbc_isd),
                mbcValueFrom: String(resp.mbc_value_from),
                mbcValueTo: String(resp.mbc_value_to),
                mbcStatus: String(resp.mbc_active),
                mbcCharges: String(resp.mbc_charges),
                mbcNostroType: String(mbcNostroType),
            });

            $(".loader").hide();
        });
    }

    const editData = () => {
        setFormMode('E');
    }

    const saveData = () => {
        // Prevent duplicate save if Save is clicked multiple times / already in progress
        if (isSaving) {
            return;
        }

        // Add mode: if this exact entry was already saved successfully once, block re-save
        if (formMode === 'A' && lastSavedFormData) {
            const currentFormData = {
                mbcIssuer: String(mbcIssuer),
                mbcFromDate: new Date(mbcFromDate).getTime(),
                mbcToDate: new Date(mbcToDate).getTime(),
                mbcIsd: String(mbcIsd),
                mbcValueFrom: String(mbcValueFrom),
                mbcValueTo: String(mbcValueTo),
                mbcStatus: String(mbcStatus),
                mbcCharges: String(mbcCharges),
                mbcNostroType: String(mbcNostroType),
            };

            const sameAsLastSaved = Object.keys(currentFormData).every(
                (key) => currentFormData[key] === lastSavedFormData[key]
            );

            if (sameAsLastSaved) {
                setMsgText("Entry Already Saved with this Details");
                setMsgBox(true);
                return;
            }
        }

        // Edit mode: if nothing actually changed, skip the aPI call
        if (formMode === 'E' && originalFormData) {
            const currentFormData = {
                mbcIssuer: String(mbcIssuer),
                mbcFromDate: new Date(mbcFromDate).getTime(),
                mbcToDate: new Date(mbcToDate).getTime(),
                mbcIsd: String(mbcIsd),
                mbcValueFrom: String(mbcValueFrom),
                mbcValueTo: String(mbcValueTo),
                mbcStatus: String(mbcStatus),
                mbcCharges: String(mbcCharges),
                mbcNostroType: String(mbcNostroType),
            };

            const noChanges = Object.keys(currentFormData).every(
                (key) => currentFormData[key] === originalFormData[key]
            );

            if (noChanges) {
                setMsgText("No Changes Made to Save");
                setMsgBox(true);
                return;
            }
        }

        $('.loader').show();
        setIsSaving(true);
        if (!mbcIssuer || !reqIsd || !mbcFromDate || !mbcToDate || !mbcValueFrom || !mbcValueTo || !mbcCharges || !mbcNostroType) {
            $('.loader').hide();
            setIsSaving(false);
            setMsgText("Fill Mandatory Fields mark with *");
            setMsgBox(true);
            return;
        } else if ((mbcValueFrom < 0) || (mbcValueTo < 0) || (mbcCharges < 0)) {
            $('.loader').hide();
            setIsSaving(false);
            setMsgText("Value From OR Value To OR Bank Charges not be Negative");
            setMsgBox(true);
            return;
        }


        const apiOption = formMode === 'A' ? "createDetails" : "updateDetails";
        const obj = {
            mbcSrno: mbcSrno,
            mbcIssuer: mbcIssuer,
            mbcIsd: mbcIsd,
            mbcFromDate: mbcFromDate,
            mbcToDate: mbcToDate,
            mbcValueFrom: mbcValueFrom,
            mbcValueTo: mbcValueTo,
            mbcStatus: mbcStatus,
            mbcCharges: mbcCharges,
            mbcNostroType: mbcNostroType
        };

        Common.callApi(Common.apiBankCharges, [sid, apiOption, JSON.stringify(obj)], (result) => {
            $('.loader').hide();
            setIsSaving(false);
            const res = JSON.parse(result);
            if (res.status === true) {
                if (res.option === "C") {
                    setMsgText("Saved Successfully");
                } else {
                    setMsgText("Update Successfully");
                }

                const savedDetails = {
                    mbcIssuer: String(mbcIssuer),
                    mbcFromDate: new Date(mbcFromDate).getTime(),
                    mbcToDate: new Date(mbcToDate).getTime(),
                    mbcIsd: String(mbcIsd),
                    mbcValueFrom: String(mbcValueFrom),
                    mbcValueTo: String(mbcValueTo),
                    mbcStatus: String(mbcStatus),
                    mbcCharges: String(mbcCharges),
                    mbcNostroType: String(mbcNostroType),
                };
                setLastSavedFormData(savedDetails);
                setOriginalFormData(savedDetails);

                // save done -> go back to main page
                setShowAddNewBtn(true);
                setFormMode('Q');
                refreshList();
            } else {
                setMsgText(res.message ? res.message : "Something went wrong");
            }
            setMsgBox(true);
        })
    }

    const cancelConfirm = () => {
        if (formMode === "A" || formMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setShowAddNewBtn(true);
        setFormMode('Q');
    }

    return (
        <>
            <Loginheader />
            <Menu />
            <Container fluid>

                {/* Page Title */}
                <Row>
                    <Col>
                        <h3>Bank Charges</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

                {showAddNewBtn ? (
                    <>
                        {/* Filters */}
                        <Row>
                            {/* <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Issuer No</Form.Label>
                                    <Form.Control
                                        value={filterIssuer}
                                        onChange={e => setFilterIssuer(e.target.value)}
                                        autoComplete="off"
                                    />
                                </Form.Group>
                            </Col> */}
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Limit</Form.Label>
                                    <Form.Select value={filterLimit} onChange={e => setFilterLimit(e.target.value)}>
                                        <option value="All">All</option>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                                        <option value="All">All</option>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Issuer</Form.Label>
                                    <Form.Select value={mbcIssuer} onChange={e => setMbcIssuer(e.target.value)}>
                                        <option value="0">All</option>
                                        {ddSrchIssuer.map((res) =>
                                            <option key={res.value} value={res.value}>{res.name}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Currency</Form.Label>
                                    <Form.Select value={mbcIsd} onChange={e => setMbcIsd(e.target.value)}>
                                        <option value="">All</option>
                                        {currency.map((res) =>
                                            <option key={res.value} value={res.value}>{res.label}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                {mbcRight.query === "1" &&
                                    <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={showList}>
                                        List
                                    </Button>
                                }&nbsp;
                                {mbcRight.add === "1" &&
                                    <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={addNew}>
                                        Add New
                                    </Button>
                                }
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {mbcRight.query === "1" && <th>View</th>}
                                            <th className="textRight">Srno</th>
                                            <th className="textRight">Issuer</th>
                                            <th>From Date</th>
                                            <th>To Date</th>
                                            <th>Currency</th>
                                            <th className="textRight">Value From</th>
                                            <th className="textRight">Value To</th>
                                            <th className="textRight">Charges</th>
                                            <th className="textRight">Nostro Type</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mbcData.map((res) => (
                                            <tr key={res.mbc_srno}>
                                                {mbcRight.query === "1" &&
                                                    <td className="textCenter">
                                                        <span
                                                            className="handCursor colorThemeBlue"
                                                            onClick={() => fillEditForm(res.mbc_srno)}
                                                        >
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    </td>
                                                }
                                                <td className="textRight">{res.mbc_srno}</td>
                                                <td className="textRight">{res.issuer_name}</td>
                                                <td>{Common.dateDMYStr(res.mbc_from_date)}</td>
                                                <td>{Common.dateDMYStr(res.mbc_to_date)}</td>
                                                <td>{res.isd_name}</td>
                                                <td className="textRight">{res.mbc_value_from}</td>
                                                <td className="textRight">{res.mbc_value_to}</td>
                                                <td className="textRight">{res.mbc_charges}</td>
                                                <td className="textRight">{res.mbc_nostro_type}</td>
                                                <td>{res.mbc_active === "1" ? "Active" : "Inactive"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                    </>
                ) : (
                    <>
                        <Row>
                            <Col>
                                <Button
                                    variant="outline-danger"
                                    className='buttonStyle'
                                    size="sm"
                                    onClick={cancelConfirm}
                                >
                                    Back
                                </Button>&nbsp;&nbsp;
                                {mbcRight.edit === "1" && formMode === 'Q' &&
                                    <Button
                                        variant="outline-success"
                                        className='buttonStyle'
                                        size="sm"
                                        onClick={editData}
                                    >
                                        Edit
                                    </Button>
                                }&nbsp;

                                {((mbcRight.edit === "1" && formMode === 'E') ||
                                    (mbcRight.add === "1" && formMode === 'A')) &&
                                    <Button
                                        variant="outline-success"
                                        className='buttonStyle'
                                        size="sm"
                                        onClick={saveData}
                                        disabled={isSaving}
                                    >
                                        Save
                                    </Button>
                                }
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col className='col-md-2 col-6'>
                                <Form.Group>
                                    <Form.Label>Srno</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={mbcSrno}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                            <Col style={{ maxWidth: "300px", flex: "0 0 400px" }}>
                                <Form.Group >
                                    <Form.Label>Issuer<span className="mandatory">*</span> </Form.Label>
                                    <Form.Select
                                        disabled={formMode === "Q"}
                                        value={mbcIssuer}
                                        onChange={(e) => setMbcIssuer(e.target.value)}
                                    >
                                        {ddSrchIssuer.map((res) =>
                                            <option key={res.value} value={res.value}>{res.name}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col style={{ maxWidth: "300px", flex: "0 0 400px" }}>
                                <Form.Group>
                                    <Form.Label>Currency<span className="mandatory">*</span></Form.Label>
                                    <Form.Select
                                        disabled={formMode === "Q"}
                                        value={mbcIsd}
                                        onChange={(e) => {
                                            setMbcIsd(e.target.value)
                                        }}  >
                                        {currency.map((res) =>
                                            <option key={res.value} value={res.value}>{res.label}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col className='col-md-2 col-6'>
                                <Form.Group>
                                    <Form.Label>From Date<span className="text-danger">*</span></Form.Label>
                                    <DatePicker
                                        className="form-control"
                                        selected={mbcFromDate}
                                        onChange={(date) => {
                                            setMbcFromDate(date)
                                            if (mbcToDate && mbcToDate < date) {
                                                setMbcToDate(date);
                                            }
                                        }}
                                        disabled={formMode === 'Q'}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        customInput={
                                            <input
                                                type="text"
                                                size='sm'
                                                onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}
                                            />
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-2 col-6'>
                                <Form.Group>
                                    <Form.Label>To Date<span className="text-danger">*</span></Form.Label>
                                    <DatePicker
                                        className="form-control"
                                        selected={mbcToDate}
                                        onChange={(date) => {
                                            if (mbcFromDate && mbcToDate < mbcFromDate) {
                                                setMbcToDate(mbcFromDate);
                                            } else {
                                                setMbcToDate(date);
                                            }
                                        }}
                                        onchangeFromdate
                                        disabled={formMode === 'Q'}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        minDate={mbcFromDate}
                                        customInput={
                                            <input
                                                type="text"
                                                size='sm'
                                                onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}
                                            />
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-2 col-6'>
                                <Form.Group>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                        value={mbcStatus}
                                        onChange={e => setMbcStatus(e.target.value)}
                                        disabled={formMode === 'Q'}
                                    >
                                        <option value={1}>Active</option>
                                        <option value={0}>Inactive</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3'>
                                <Form.Group >
                                    <Form.Label>Nostro Type<span className="mandatory">*</span></Form.Label>
                                    <Form.Select
                                        disabled={formMode === "Q"}
                                        value={mbcNostroType}
                                        onChange={(e) => setMbcNostroType(e.target.value)} >
                                        <option value="0" >Select</option>
                                        <option value="OUR">OUR</option>
                                        <option value="BEN">BEN</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col className='col-md-2 col-6'>
                                <Form.Group>
                                    <Form.Label>Value From<span className="mandatory">*</span></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Value From"
                                        value={mbcValueFrom}
                                        onChange={e => setMbcValueFrom(e.target.value)}
                                        disabled={formMode === 'Q'}
                                        autoComplete="off"
                                    />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-2 col-6'>
                                <Form.Group>
                                    <Form.Label>Value To<span className="mandatory">*</span></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Value To"
                                        value={mbcValueTo}
                                        onChange={e => setMbcValueTo(e.target.value)}
                                        disabled={formMode === 'Q'}
                                        autoComplete="off"
                                    />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-2 col-6'>
                                <Form.Group>
                                    <Form.Label>Bank Charge<span className="mandatory">*</span></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Value To"
                                        value={mbcCharges}
                                        onChange={e => setMbcCharges(e.target.value)}
                                        disabled={formMode === 'Q'}
                                        autoComplete="off"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                    </>
                )}

            </Container >
            < Dialog isOpen={isMsgBox} onClose={() => setMsgBox(false)}>
                {msgText}
            </Dialog >
            <DialogYesNo isOpen={isMsgBoxYN} onYes={cancelData} onNo={() => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
        </>
    );
}

export default Bank_Charges_List;